// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-assistant-feedback {
  padding: 12px 14px;
  margin-top: 10px;
  border: 1px solid #bfd2f5;
  border-radius: 12px;
  background: #f2f6ff;
  color: #263d64;
  font-size: 13px;
  line-height: 1.5;
  max-width: 440px;
}
.ticket-assistant-feedback p {
  margin: 5px 0 10px;
}
.ticket-assistant-feedback div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ticket-assistant-feedback button {
  padding: 7px 10px;
  border: 1px solid #afc3e7;
  border-radius: 7px;
  background: white;
  color: #263d64;
  cursor: pointer;
  font: inherit;
}
.ticket-assistant-feedback button[aria-pressed=true] {
  background: #254f93;
  color: white;
  border-color: #254f93;
}
.ticket-assistant-feedback button:disabled {
  opacity: 0.6;
  cursor: wait;
}
.ticket-assistant-feedback span {
  display: block;
  margin-top: 6px;
}
.ticket-assistant-feedback [role=alert] {
  color: #a62b32;
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/assistantReplyFeedback.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EAAoB,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EACjE,mBAAA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AAQ5E;AAPI;EAAI,kBAAA;AAUR;AATI;EAAM,aAAA;EAAe,eAAA;EAAiB,QAAA;AAc1C;AAbI;EAAS,iBAAA;EAAmB,yBAAA;EAA2B,kBAAA;EAAoB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;EAAiB,aAAA;AAsBnI;AArBI;EAA8B,mBAAA;EAAqB,YAAA;EAAc,qBAAA;AA0BrE;AAzBI;EAAkB,YAAA;EAAa,YAAA;AA6BnC;AA5BI;EAAO,cAAA;EAAgB,eAAA;AAgC3B;AA/BI;EAAiB,cAAA;AAkCrB","sourcesContent":[".ticket-assistant-feedback {\n    padding: 12px 14px; margin-top: 10px; border: 1px solid #bfd2f5; border-radius: 12px;\n    background: #f2f6ff; color: #263d64; font-size: 13px; line-height: 1.5; max-width: 440px;\n    p { margin: 5px 0 10px; }\n    div { display: flex; flex-wrap: wrap; gap: 8px; }\n    button { padding: 7px 10px; border: 1px solid #afc3e7; border-radius: 7px; background: white; color: #263d64; cursor: pointer; font: inherit; }\n    button[aria-pressed=\"true\"] { background: #254f93; color: white; border-color: #254f93; }\n    button:disabled { opacity: .6; cursor: wait; }\n    span { display: block; margin-top: 6px; }\n    [role=\"alert\"] { color: #a62b32; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
